import { render, staticRenderFns } from "./InceptionDashboardNumbers.vue?vue&type=template&id=4e830d85&scoped=true"
import script from "./InceptionDashboardNumbers.vue?vue&type=script&lang=ts"
export * from "./InceptionDashboardNumbers.vue?vue&type=script&lang=ts"
import style0 from "./InceptionDashboardNumbers.vue?vue&type=style&index=0&id=4e830d85&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e830d85",
  null
  
)

export default component.exports